<template>
  <div class="next-app">
    <NuxtLayout :name="layout" :key="layout">
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script setup>
const route = useRoute();
const layout = computed(()=>route.meta.layout || 'default');
</script>
